import { buildIntlProps, getCurrentLocale } from "@leagueplatform/locales";
import { CHAT_UNAVAILABLE_REASON } from "./live-chat-constants";
import type { ChatUnavailableReason } from "./live-chat-constants";

// Locale-aware notice for the CHAT_ENDED error screen. Resolves via the
// SDK's own message pool so we don't maintain a second intl instance;
// English literals mirror en.json so the surface never blanks out if the
// SDK config isn't set yet (early lifecycle, tests).
// Only `out_of_hours` says the chat is closed; any other reason, or none,
// gets the generic start-failure copy (iOS parity).
export function chatUnavailableStrings(reason?: ChatUnavailableReason): {
  title: string;
  body: string;
} {
  let messages: Partial<Record<string, string>> = {};
  const fallbackDefaultMessage = {
    title: "We couldn't start the chat",
    body: "There was an issue, please try again.",
  };

  try {
    messages = buildIntlProps(getCurrentLocale()).messages;
    switch (reason) {
      case CHAT_UNAVAILABLE_REASON.OUT_OF_HOURS:
        return {
          title:
            messages.STR_LIVE_CHAT_UNAVAILABLE_TITLE ??
            "Live Chat is currently closed",
          body:
            messages.STR_LIVE_CHAT_UNAVAILABLE_MESSAGE ??
            "Please come back at a later time",
        };
      default:
        return {
          title:
            messages.STR_LIVE_CHAT_DEFAULT_UNAVAILABLE_TITLE ??
            fallbackDefaultMessage.title,
          body:
            messages.STR_LIVE_CHAT_DEFAULT_UNAVAILABLE_MESSAGE ??
            fallbackDefaultMessage.body,
        };
    }
  } catch {
    // Config not set yet; keep the closed copy for out of hours.
    if (reason === CHAT_UNAVAILABLE_REASON.OUT_OF_HOURS) {
      return {
        title: "Live Chat is currently closed",
        body: "Please come back at a later time",
      };
    }
    return {
      title: fallbackDefaultMessage.title,
      body: fallbackDefaultMessage.body,
    };
  }
}
